import { render, staticRenderFns } from "./nutritionalPlan.vue?vue&type=template&id=20d731c2&scoped=true&"
import script from "./nutritionalPlan.vue?vue&type=script&lang=js&"
export * from "./nutritionalPlan.vue?vue&type=script&lang=js&"
import style0 from "./nutritionalPlan.vue?vue&type=style&index=0&id=20d731c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d731c2",
  null
  
)

export default component.exports